import { canAccessRoute } from './routeAccess'

export function canSeeNavigationItem(access, key) {
  return canAccessRoute(access, key)
}
